import {Component, Input, OnInit} from '@angular/core';
import {ActionModel} from '../../models/action.model';
import {CustomerModel} from '../../models/customer.model';
import {ContactModel} from '../../models/contact.model';

@Component({
    selector: 'customer-contact-details-opportunity',
    templateUrl: './customer-contact-details-opportunity.component.html',
    styleUrls: ['./customer-contact-details-opportunity.component.scss'],
})
export class CustomerContactDetailsOpportunityComponent implements OnInit {
    @Input() action: ActionModel;

    constructor() {
    }

    ngOnInit() {
        if (!this.action.customerDTO) {
            this.action.customerDTO = new CustomerModel();
        }
        if (!this.action.contactDTO) {
            this.action.contactDTO = new ContactModel();
        }
    }

}
